export default __webpack_public_path__ + "static/media/me-icon.c1e9987e.webp";